import isKey from '@/functions/existing_key';

export default function isExistingIssue(params) {
  return isKey(params, 'issueId') && !['null', 'undefined'].includes(params?.issueId);
}
